  (function () {
    function initGsapScrollRevealSection(root) {
    if (!root || root.dataset.sutyoGsapScrollRevealReady === 'true') return;

    root.dataset.sutyoGsapScrollRevealReady = 'true';

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heroPanel = root.querySelector('[data-hero-panel]');
    var scrollShell = root.querySelector('[data-scroll-shell]');
    var stage = root.querySelector('.sutyo-gsap-scroll-reveal__stage');
    var hint = root.querySelector('[data-scroll-hint]');
    var mediaFrame = root.querySelector('[data-media-frame]');
    var heroHeadingItems = root.querySelectorAll('[data-hero-heading-item]');
    var video = root.querySelector('.sutyo-gsap-scroll-reveal__video');
    var videoControls = root.querySelector('[data-video-controls]');
    var progressInput = root.querySelector('[data-video-progress]');
    var volumeWrap = root.querySelector('[data-volume-wrap]');
    var volumeInput = root.querySelector('[data-video-volume]');
    var muteButton = root.querySelector('[data-video-mute]');
    var muteLabel = root.querySelector('[data-video-mute-label]');
    var videoController = null;
    var cleanup = null;

    if (!heroPanel || !scrollShell || !stage) return;

    function destroy() {
      if (typeof cleanup === 'function') {
        cleanup();
        cleanup = null;
      }
    }

    function initReducedMotion() {
      root.classList.add('is-reduced-motion');
    }

    function initHeadingRotation() {
      var headingCount = heroHeadingItems ? heroHeadingItems.length : 0;
      var activeIndex = 0;
      var rotationTimer = null;
      var index = 0;
      var rotationDelay = Math.max(Number(root.dataset.headingRotationSpeed) || 3, 0.5) * 1000;

      if (headingCount < 2) return function () {};

      function setActiveHeading(nextIndex) {
        for (index = 0; index < headingCount; index += 1) {
          heroHeadingItems[index].classList.toggle('is-active', index === nextIndex);
        }
      }

      setActiveHeading(activeIndex);

      if (reducedMotion) return function () {};

      rotationTimer = window.setInterval(function () {
        activeIndex = (activeIndex + 1) % headingCount;
        setActiveHeading(activeIndex);
      }, rotationDelay);

      return function () {
        if (rotationTimer) {
          window.clearInterval(rotationTimer);
        }
      };
    }

    function initVideoControls() {
      if (!mediaFrame || !video || !videoControls || !progressInput || !volumeWrap || !volumeInput || !muteButton || !muteLabel) {
        return {
          destroy: function () {},
          setScrollPlaybackState: function () {}
        };
      }

      var isSeeking = false;
      var userPaused = false;
      var scrollPlaybackActive = false;
      var lastVolume = Number(volumeInput.value) || 0.5;
      var hideControlsTimer = null;
      var controlsVisible = false;
      var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function paintRange(input, percent) {
        input.style.background = 'linear-gradient(90deg, #ffffff 0%, #ffffff ' + percent + '%, rgb(255 255 255 / 38%) ' + percent + '%, rgb(255 255 255 / 38%) 100%)';
      }

      function clearHideControlsTimer() {
        if (hideControlsTimer) {
          window.clearTimeout(hideControlsTimer);
          hideControlsTimer = null;
        }
      }

      function hideControls() {
        if (!supportsHover) return;
        controlsVisible = false;
        videoControls.classList.remove('is-visible');
      }

      function showControls() {
        controlsVisible = true;
        videoControls.classList.add('is-visible');
      }

      function queueHideControls() {
        if (!supportsHover) return;
        clearHideControlsTimer();
        hideControlsTimer = window.setTimeout(function () {
          if (document.activeElement === progressInput || document.activeElement === volumeInput || document.activeElement === muteButton) {
            queueHideControls();
            return;
          }

          hideControls();
        }, 2000);
      }

      function revealControls() {
        if (!supportsHover) return;
        showControls();
        queueHideControls();
      }

      function syncPlaybackState() {
        mediaFrame.classList.toggle('is-paused', video.paused);
      }

      function attemptPlay(force) {
        if (!force && userPaused) return;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      function isControlsTarget(target) {
        return !!(target && target.closest && target.closest('[data-video-controls]'));
      }

      function togglePlayback(event) {
        if (isControlsTarget(event.target)) return;

        if (video.paused) {
          userPaused = false;
          attemptPlay(true);
        } else {
          userPaused = true;
          video.pause();
        }

        revealControls();
      }

      function maybeResumePlayback() {
        if (userPaused || !scrollPlaybackActive) return;

        var rect = root.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

        if (video.paused) {
          attemptPlay(false);
        }
      }

      function handleMouseLeave() {
        clearHideControlsTimer();
        hideControls();
      }

      function setMutedState(isMuted) {
        video.muted = isMuted;
        muteButton.classList.toggle('is-muted', isMuted);
        muteButton.setAttribute('aria-pressed', String(isMuted));
        muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
        muteLabel.textContent = isMuted ? 'Muted' : 'Unmuted';
        volumeWrap.classList.toggle('is-active', !isMuted);
        volumeInput.disabled = isMuted;
      }

      function syncProgress() {
        if (isSeeking || !video.duration) return;
        var progress = (video.currentTime / video.duration) * 100;
        progressInput.value = String(progress);
        paintRange(progressInput, progress);
      }

      function syncDuration() {
        if (!video.duration) {
          progressInput.value = '0';
          paintRange(progressInput, 0);
          return;
        }

        syncProgress();
      }

      function handleProgressInput() {
        if (!video.duration) return;
        var progress = Number(progressInput.value);
        paintRange(progressInput, progress);
        video.currentTime = (progress / 100) * video.duration;
      }

      function handleVolumeInput() {
        var nextVolume = Number(volumeInput.value);
        if (nextVolume > 0) {
          lastVolume = nextVolume;
        }

        video.volume = nextVolume;
        paintRange(volumeInput, nextVolume * 100);

        if (nextVolume <= 0) {
          setMutedState(true);
          return;
        }

        setMutedState(false);
      }

      function toggleMute() {
        if (video.muted || video.volume <= 0) {
          var nextVolume = lastVolume > 0 ? lastVolume : 0.5;
          volumeInput.value = String(nextVolume);
          video.volume = nextVolume;
          paintRange(volumeInput, nextVolume * 100);
          setMutedState(false);
          revealControls();
          return;
        }

        lastVolume = video.volume > 0 ? video.volume : lastVolume;
        video.volume = 0;
        volumeInput.value = '0';
        paintRange(volumeInput, 0);
        setMutedState(true);
        revealControls();
      }

      function setScrollPlaybackState(isActive) {
        scrollPlaybackActive = !!isActive;

        if (!scrollPlaybackActive) {
          if (!video.paused) {
            video.pause();
          }

          if (!userPaused) {
            try {
              video.currentTime = 0;
            } catch (error) {}
            progressInput.value = '0';
            paintRange(progressInput, 0);
          }

          syncPlaybackState();
          return;
        }

        if (!userPaused) {
          attemptPlay(false);
        }
      }

      function startSeeking() {
        isSeeking = true;
        showControls();
        clearHideControlsTimer();
      }

      function stopSeeking() {
        isSeeking = false;
        handleProgressInput();
        queueHideControls();
      }

      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.autoplay = false;
      video.playsInline = true;
      progressInput.value = '0';
      volumeInput.value = String(lastVolume);
      paintRange(progressInput, 0);
      paintRange(volumeInput, lastVolume * 100);
      setMutedState(true);
      syncPlaybackState();
      if (supportsHover) {
        hideControls();
      } else {
        showControls();
      }

      video.addEventListener('play', syncPlaybackState);
      video.addEventListener('pause', syncPlaybackState);
      video.addEventListener('timeupdate', syncProgress);
      video.addEventListener('loadedmetadata', syncDuration);
      video.addEventListener('durationchange', syncDuration);
      video.addEventListener('loadeddata', maybeResumePlayback);
      video.addEventListener('canplay', maybeResumePlayback);
      mediaFrame.addEventListener('mouseenter', revealControls);
      mediaFrame.addEventListener('mousemove', revealControls);
      mediaFrame.addEventListener('mouseleave', handleMouseLeave);
      mediaFrame.addEventListener('click', togglePlayback);
      progressInput.addEventListener('pointerdown', startSeeking);
      progressInput.addEventListener('pointerup', stopSeeking);
      progressInput.addEventListener('input', handleProgressInput);
      progressInput.addEventListener('change', stopSeeking);
      volumeInput.addEventListener('input', handleVolumeInput);
      volumeInput.addEventListener('change', handleVolumeInput);
      muteButton.addEventListener('click', toggleMute);
      progressInput.addEventListener('focus', showControls);
      progressInput.addEventListener('blur', queueHideControls);
      volumeInput.addEventListener('focus', showControls);
      volumeInput.addEventListener('blur', queueHideControls);
      muteButton.addEventListener('focus', showControls);
      muteButton.addEventListener('blur', queueHideControls);
      window.addEventListener('scroll', maybeResumePlayback, { passive: true });
      window.addEventListener('resize', maybeResumePlayback);
      document.addEventListener('visibilitychange', maybeResumePlayback);

      return {
        setScrollPlaybackState: setScrollPlaybackState,
        destroy: function () {
          clearHideControlsTimer();
          video.removeEventListener('play', syncPlaybackState);
          video.removeEventListener('pause', syncPlaybackState);
          video.removeEventListener('timeupdate', syncProgress);
          video.removeEventListener('loadedmetadata', syncDuration);
          video.removeEventListener('durationchange', syncDuration);
          video.removeEventListener('loadeddata', maybeResumePlayback);
          video.removeEventListener('canplay', maybeResumePlayback);
          mediaFrame.removeEventListener('mouseenter', revealControls);
          mediaFrame.removeEventListener('mousemove', revealControls);
          mediaFrame.removeEventListener('mouseleave', handleMouseLeave);
          mediaFrame.removeEventListener('click', togglePlayback);
          progressInput.removeEventListener('pointerdown', startSeeking);
          progressInput.removeEventListener('pointerup', stopSeeking);
          progressInput.removeEventListener('input', handleProgressInput);
          progressInput.removeEventListener('change', stopSeeking);
          volumeInput.removeEventListener('input', handleVolumeInput);
          volumeInput.removeEventListener('change', handleVolumeInput);
          muteButton.removeEventListener('click', toggleMute);
          progressInput.removeEventListener('focus', showControls);
          progressInput.removeEventListener('blur', queueHideControls);
          volumeInput.removeEventListener('focus', showControls);
          volumeInput.removeEventListener('blur', queueHideControls);
          muteButton.removeEventListener('focus', showControls);
          muteButton.removeEventListener('blur', queueHideControls);
          window.removeEventListener('scroll', maybeResumePlayback);
          window.removeEventListener('resize', maybeResumePlayback);
          document.removeEventListener('visibilitychange', maybeResumePlayback);
        }
      };
    }

    function initLockedScrollEffect() {
      var stageHeight = 0;
      var maxOffset = 0;
      var introOffset = 0;
      var touchStartY = 0;
      var gestureStartY = 0;
      var gestureStartTime = 0;
      var returnArmed = false;
      var videoHoldDistance = 300;
      var animFrame = null;
      var isAnimating = false;
      var VELOCITY_THRESHOLD = Number(root.dataset.swipeVelocityThreshold);
      var DISTANCE_THRESHOLD = Number(root.dataset.swipeDistanceThreshold);

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function animateTo(target) {
        if (animFrame) {
          cancelAnimationFrame(animFrame);
          animFrame = null;
        }

        var startOffset = introOffset;
        var delta = target - startOffset;

        if (Math.abs(delta) < 1) {
          introOffset = target;
          applyIntro();
          isAnimating = false;
          return;
        }

        var duration = Math.max(280, Math.min(520, Math.abs(delta) * 1.3));
        var startTime = null;
        isAnimating = true;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var t = Math.min(elapsed / duration, 1);

          introOffset = startOffset + delta * easeOutCubic(t);
          applyIntro();

          if (t < 1) {
            animFrame = requestAnimationFrame(step);
          } else {
            introOffset = target;
            applyIntro();
            isAnimating = false;
            animFrame = null;
          }
        }

        animFrame = requestAnimationFrame(step);
      }

      function getViewportTopOffset() {
        var selectors = [
          '.shopify-section-group-header-group',
          '.section-header',
          '.site-header',
          '.header-wrapper',
          '#shopify-section-header',
          'header'
        ];
        var index = 0;

        for (index = 0; index < selectors.length; index += 1) {
          var element = document.querySelector(selectors[index]);
          if (!element) continue;

          var rect = element.getBoundingClientRect();
          if (rect.height > 0) {
            return rect.height;
          }
        }

        return 0;
      }

      function getProgress() {
        if (!stageHeight) return 0;
        return clamp(introOffset / stageHeight, 0, 1);
      }

      function applyIntro() {
        var progress = getProgress();
        var hintProgress = clamp(progress / 0.2, 0, 1);
        var heroOffset = clamp(introOffset, 0, stageHeight);

        heroPanel.style.transform = 'translate3d(0, ' + (-heroOffset) + 'px, 0)';
        heroPanel.style.pointerEvents = progress >= 1 ? 'none' : 'auto';

        if (hint) {
          hint.style.opacity = String(1 - hintProgress);
          hint.style.visibility = hintProgress >= 1 ? 'hidden' : 'visible';
        }

        if (videoController && typeof videoController.setScrollPlaybackState === 'function') {
          videoController.setScrollPlaybackState(progress >= 0.5);
        }

        if (progress <= 0) {
          returnArmed = false;
        }
      }

      function measure() {
        stageHeight = stage.offsetHeight || 0;
        maxOffset = stageHeight + videoHoldDistance;
        introOffset = clamp(introOffset, 0, maxOffset);
        applyIntro();
      }

      function isSectionInView() {
        var rect = scrollShell.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      }

      function isSectionPinnedForReturn() {
        var rect = scrollShell.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var viewportTopOffset = getViewportTopOffset();
        var availableHeight = viewportHeight - viewportTopOffset;
        var visibleTop = rect.top >= viewportTopOffset - 2;
        var visibleBottom = rect.bottom <= viewportHeight + 2;

        if (rect.height > availableHeight + 2) {
          return visibleTop;
        }

        return visibleTop && visibleBottom;
      }

      function consume(deltaY) {
        if (deltaY > 0) {
          returnArmed = false;
          if (!isSectionInView() || introOffset >= maxOffset) return false;
        } else if (deltaY < 0) {
          if (introOffset <= 0) {
            returnArmed = false;
            return false;
          }

          if (introOffset < maxOffset) {
            if (!isSectionInView()) return false;
            returnArmed = false;
          } else {
            if (!returnArmed) {
              if (!isSectionPinnedForReturn()) return false;
              returnArmed = true;
            }
          }
        } else {
          return false;
        }

        var nextOffset = clamp(introOffset + deltaY, 0, maxOffset);
        if (nextOffset === introOffset) return false;

        introOffset = nextOffset;
        applyIntro();
        return true;
      }

      function handleWheel(event) {
        if (consume(event.deltaY)) {
          event.preventDefault();
        }
      }

      function handleTouchStart(event) {
        if (!event.touches || !event.touches.length) return;
        touchStartY = event.touches[0].clientY;
        gestureStartY = touchStartY;
        gestureStartTime = Date.now();

        if (animFrame) {
          cancelAnimationFrame(animFrame);
          animFrame = null;
          isAnimating = false;
        }
      }

      function handleTouchMove(event) {
        if (!event.touches || !event.touches.length) return;
        if (isAnimating) return;

        var currentY = event.touches[0].clientY;
        var deltaY = touchStartY - currentY;

        if (consume(deltaY)) {
          touchStartY = currentY;
          event.preventDefault();
        }
      }

      function handleTouchEnd(event) {
        if (isAnimating) return;
        if (introOffset <= 0 || introOffset >= maxOffset) return;

        var endY = event.changedTouches && event.changedTouches[0]
          ? event.changedTouches[0].clientY
          : touchStartY;
        var totalDelta = gestureStartY - endY;
        var elapsed = Date.now() - gestureStartTime;
        var velocity = elapsed > 0 ? totalDelta / elapsed : 0;

        if (velocity > VELOCITY_THRESHOLD || totalDelta > DISTANCE_THRESHOLD) {
          animateTo(maxOffset);
        } else if (velocity < -VELOCITY_THRESHOLD || totalDelta < -DISTANCE_THRESHOLD) {
          animateTo(0);
        } else {
          animateTo(introOffset > maxOffset * 0.5 ? maxOffset : 0);
        }
      }

      window.addEventListener('wheel', handleWheel, { passive: false });
      window.addEventListener('touchstart', handleTouchStart, { passive: true });
      window.addEventListener('touchmove', handleTouchMove, { passive: false });
      window.addEventListener('touchend', handleTouchEnd, { passive: true });
      window.addEventListener('resize', measure);
      measure();

      return function () {
        if (animFrame) cancelAnimationFrame(animFrame);
        window.removeEventListener('wheel', handleWheel);
        window.removeEventListener('touchstart', handleTouchStart);
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
        window.removeEventListener('resize', measure);
      };
    }

    var destroyHeadingRotation = initHeadingRotation();
    videoController = initVideoControls();

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail && event.detail.sectionId === root.dataset.sectionId) {
        if (typeof destroyHeadingRotation === 'function') {
          destroyHeadingRotation();
        }
        if (videoController && typeof videoController.destroy === 'function') {
          videoController.destroy();
        }
        destroy();
      }
    });

    if (reducedMotion) {
      initReducedMotion();
    } else {
      cleanup = initLockedScrollEffect();
    }
    }

    function initAllGsapScrollRevealSections() {
      document.querySelectorAll('[data-sutyo-gsap-scroll-reveal]').forEach(initGsapScrollRevealSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllGsapScrollRevealSections, { once: true });
    } else {
      initAllGsapScrollRevealSections();
    }

    document.addEventListener('shopify:section:load', initAllGsapScrollRevealSections);
  })();
